import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext';
import { GenericDataContext, GenericDataContextPayload } from '../../../../../../context/genericDataContext';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { accountSetupBreadcrumb, carouselTemplateGroups, channelsBreadcrumb, homeBreadcrumb, templateMessagesBreadcrumb } from '../../../../../../utils/breadcrumb';
import { formatDateAccordingToTimezoneUsingMoment, getWabaName, hasCarouselTemplateGroupManageAccess } from '../../../../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { carouselTemplateGroup } from '../../../../../../models/axiosModel';
import { useShallow } from "zustand/react/shallow";
import { useCarouselTemplateGroupStore } from '../../../../../../store/carouselTemplateGroupStore';
import { Grid, useMediaQuery } from '@mui/material';
import { GlobalTable } from '../../../../../utility/globalTable';
import moment from 'moment';
import globalStrenameDocumentyles from "../../../../../../assets/renameDocument.svg";
import deleteDoc from "../../../../../../assets/deleteDoc.svg";
import GlobalPopUp from '../../../../../utility/globalPopUp';
import CreateTemplateGroupPopup from './components/createTemplateGroupPopup';
import GlobalDeletePopup from '../../../../../utility/globalDeletePopup/globalDeletePopup';
import agent from '../../../../../../services/api';
import { timeStampFormat } from './constants';
import { useGenericStore } from '../../../../../../store/genericStore';
import { findWhatsAppIntegration } from '../../../../../../pages/ruleBasedInbox/utils';

const CarouselTemplateGroup = () => {
    
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    let id = searchParams.get("id");
    const pathname = window.location.pathname.toLowerCase();

    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const { getMetaIntegrationList, integrationListNewStructure, setIntegrationDetails, integrationDetails } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { setBreadCrumbs } = useContext(GenericDataContext) as GenericDataContextPayload;
    const { setFlagLoading, handleError, userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;
    const { getCarouselTemplateGroups, carouselTemplateGroupData, setFlagCreateTemplateGroupPopup, flagCreateTemplateGroupPopup, setSelectedTemplateGroup, selectedTemplateGroup } = useCarouselTemplateGroupStore(
        useShallow((state) => ({
            getCarouselTemplateGroups: state.getCarouselTemplateGroups,
            carouselTemplateGroupData: state.carouselTemplateGroupData,
            setFlagCreateTemplateGroupPopup: state.setFlagCreateTemplateGroupPopup,
            flagCreateTemplateGroupPopup: state.flagCreateTemplateGroupPopup,
            setSelectedTemplateGroup: state.setSelectedTemplateGroup,
            selectedTemplateGroup: state.selectedTemplateGroup,
        }))
    );

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [flagShowDeleteConfirmation, setFlagShowDeleteConfirmation] = useState<boolean>(false);

    const getCarouselTemplateGroupsApi = async (meta_integration_whatsapp_id: number) => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getCarouselTemplateGroups(meta_integration_whatsapp_id);
        if(!(res.status)){
            handleError(res);
        } 
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    const getMetaIntegrationListApi = async () => {
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: true }))
        const res = await getMetaIntegrationList(true)
        if (!(res.status)) {
            handleError(res);
        }
        setFlagLoading((prevState) => ({ ...prevState, flagRoundLoader: false }))
    }

    useLayoutEffect(() => {
        if (!integrationListNewStructure) {
            getMetaIntegrationListApi();
        }
    }, []);

    useEffect(() => {
        (async () => {
            if (searchParams.has('id')) {
                if (integrationListNewStructure && integrationListNewStructure.length > 0) {
                    let integration = findWhatsAppIntegration(integrationListNewStructure, id ?? '');
                    if (integration) {
                        let whatsapp_meta_integration_id = integration.meta_integration_whatsapp_id
                        await getCarouselTemplateGroupsApi(whatsapp_meta_integration_id)
                        setIntegrationDetails(integration)
                    } else {
                        navigate('/channels/viewintegration/whatsapp')
                    }
                }
            } else {
                setIntegrationDetails(null)
            }
        })()
    }, [integrationListNewStructure])

    useEffect(() => {
        if (id) {
            const updatedBreadcrumbs = [
                homeBreadcrumb,
                { ...channelsBreadcrumb },
                { name: getWabaName(integrationListNewStructure, Number(searchParams.get('id')), "Whatsapp"), path: `/channels/viewintegration/Whatsapp?id=${id}`, isActive: false, isSamePageRedirecting: pathname === "/channels/viewintegration/whatsapp" },
                { ...templateMessagesBreadcrumb, path: `/channels/viewintegration/whatsapp/templatemessages?id=${id}` },
                { ...carouselTemplateGroups, isActive: true },
            ];
            setBreadCrumbs(updatedBreadcrumbs);
        } else {
            setBreadCrumbs([homeBreadcrumb, { ...channelsBreadcrumb }, { ...accountSetupBreadcrumb, isActive: true }]);
        }
    }, [id, integrationListNewStructure])

    const templateGroupColumns = [
        {
            name: "Carousel Template Group Name",
            alignment: "left",
            flagIcon: false,
            valueKey: 'carousel_template_group_name'
        },
        {
            name: "Maximum Card Count",
            alignment: "left",
            flagIcon: false,
            valueKey: 'max_card_count',
            iconKey: "documentIco",
        },
        {
            name: "Created At",
            alignment: "left",
            flagIcon: false,
            valueKey: "created_at",
            iconKey: "documentIco",
        },
        ...(hasCarouselTemplateGroupManageAccess(apiRoutesPermissionAssignment, userDetail) ? 
            [
                {
                    name: "",
                    alignment: "right",
                    flagIcon: true,
                    valueKey: "",
                    iconKey: "editIcon"
                }
            ] : []
        )
    ]

    const menuItems = [
        { 
            label: 'Edit', 
            icon: <img src={globalStrenameDocumentyles} alt="edit" width={"16"} height={"16"} />, 
            action: (e: carouselTemplateGroup) => onClickOfRow(e), 
            disabled: !hasCarouselTemplateGroupManageAccess(apiRoutesPermissionAssignment, userDetail)
        },
        { 
            label: 'Delete', 
            icon: <img src={deleteDoc} alt="delete" width={"16"} height={"16"} />, 
            action: (e: carouselTemplateGroup) => { setFlagShowDeleteConfirmation(true); setSelectedTemplateGroup(e) }, 
            disabled: !hasCarouselTemplateGroupManageAccess(apiRoutesPermissionAssignment, userDetail)
        },
    ];

    const getSortedCarouselTemplateGroupData = () => {
        if(carouselTemplateGroupData){
            return carouselTemplateGroupData?.map((templateGroup: carouselTemplateGroup) => {
                return {
                    ...templateGroup,
                    created_at: formatDateAccordingToTimezoneUsingMoment(templateGroup?.created_at, userDetail?.timezone_hour)
                }
            })?.sort((a: carouselTemplateGroup, b: carouselTemplateGroup) => {
                const timeA =  moment(a.created_at).format(timeStampFormat);
                const timeB = moment(b.created_at).format(timeStampFormat);
                return timeB.localeCompare(timeA)
            })
        }
        return [];
    }

    const onClickOfRow = (rowDetail: carouselTemplateGroup) => {
        setSelectedTemplateGroup(rowDetail);
        setFlagCreateTemplateGroupPopup(true);
    }

    const onCloseOfTemplateGroupPopup = () => {
        setFlagCreateTemplateGroupPopup(false);
        setSelectedTemplateGroup(null);
    }

    const onCloseOfDeletePopup = () => {
        setFlagShowDeleteConfirmation(false);
        setSelectedTemplateGroup(null);
    }

    const deleteCarouselTemplateGroup = async (selectedTemplateGroup: carouselTemplateGroup | null) => {
        if(selectedTemplateGroup){
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
            const res = await agent.deleteCarouselTemplateGroups.delete(selectedTemplateGroup?.carousel_template_group_id);
            if(!(res.status)){
                handleError(res);
            } else {
                showSuccess("Carousel Template Group Deleted Successfully")
                getCarouselTemplateGroupsApi(integrationDetails?.meta_integration_whatsapp_id ?? Number(id))
            }
            setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
        }
    }

    return (
        <>
            <Grid item xs={12} paddingBlock={2}>
                <GlobalTable
                    headerList={templateGroupColumns}
                    rowData={getSortedCarouselTemplateGroupData()}
                    tableContainerMinHeight={"auto"}
                    onCellClick={(e: React.SyntheticEvent, rowDetail: carouselTemplateGroup) => { onClickOfRow(rowDetail) }}
                    onRowClick={(e: React.SyntheticEvent) => {}}
                    rowAllowEdit={false}
                    flagPagination 
                    tableHeight={"82vh"}
                    menuItemsFromParent={menuItems}
                />
                
            </Grid>

            {flagCreateTemplateGroupPopup && 
                <GlobalPopUp
                    open={flagCreateTemplateGroupPopup}
                    handleClose={() => onCloseOfTemplateGroupPopup()}
                    onClose={() => onCloseOfTemplateGroupPopup()}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "650px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "700px"}
                    borderRadius='10px'
                    titlePadding='0px'
                >
                    <CreateTemplateGroupPopup
                        getCarouselTemplateGroupsApi={getCarouselTemplateGroupsApi}
                    />
                </GlobalPopUp>
            }

            {flagShowDeleteConfirmation && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete this template group`}
                    open={flagShowDeleteConfirmation}
                    onClose={() => { onCloseOfDeletePopup() }}
                    onDelete={() => {
                        deleteCarouselTemplateGroup(selectedTemplateGroup);
                        onCloseOfDeletePopup();
                    }}
                />
            }
        </>
    )
}

export default CarouselTemplateGroup
